import { matchPath, useLocation } from 'react-router-dom';

import { Card } from '@/components/ui/card';

import { CapacityTestDetails } from '../capacity-test-details';
import { CapacityTestFormCreate } from '../capacity-test-form-create/capacity-test-form-create';

export type CapacityTestContentProps = {
  selectedId: string | undefined;
  className?: string;
};

export function CapacityTestContent({
  selectedId,
  className,
}: CapacityTestContentProps) {
  const location = useLocation();
  const isCreateMode = matchPath(location.pathname, {
    path: '/asset/:siteId/capacity-test/new',
    exact: true,
  });

  if (isCreateMode) {
    return (
      <div className={className}>
        <Card className="mx-auto my-4 max-w-3xl">
          <CapacityTestFormCreate />
        </Card>
      </div>
    );
  }

  if (selectedId) {
    return (
      <div className={className}>
        <div className="mx-auto my-4 max-w-5xl">
          <CapacityTestDetails selectedId={selectedId} />
        </div>
      </div>
    );
  }

  return (
    <div className={className}>
      <div className="mx-auto my-4 max-w-5xl">
        <div>
          <div className="h-[33vh]"></div>
          <p className="my-auto flex h-36 items-center justify-center rounded border border-dashed border-zinc-400/20 text-center italic text-zinc-500">
            Select or create a capacity test.
          </p>
        </div>
      </div>
    </div>
  );
}
